import React from "react";
import { Box } from "@catchoftheday/cg-components";
export const SideImageZone = (props) => {
    return (<Box width={{
            xs: "100%",
            md: "50%",
        }} overflow="hidden" {...props}/>);
};
export const ContentZone = (props) => {
    return (<Box width={{
            xs: "100%",
            md: "50%",
        }} py={{
            xs: 6,
            md: 9,
        }} px={{
            xs: 4,
            md: 9,
        }} color="onePass.textPrimary" fontFamily="onePass" {...props}/>);
};
